import { render } from "./ExampleStats.vue?vue&type=template&id=7d05da48"
import script from "./ExampleStats.vue?vue&type=script&lang=ts"
export * from "./ExampleStats.vue?vue&type=script&lang=ts"
script.render = render

export default script